import Vue from "vue";
import "babel-polyfill";
import Vuex from "vuex";
import getters from "./getters";
import common from "./common";
Vue.use(Vuex);
const state = {
  //要设置的全局访问的state对象
};
const store = new Vuex.Store({
  state,
  modules: {
    common
  },

  getters
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js